import React from 'react';
import s from './s.module.less';
import { efaxFaqLarkUrl } from 'utils/common';

const FAQ = () => {
    return (
        <div className={s.wrap}>
            <h2 className={s.title}>Frequently asked questions</h2>
            <iframe src={efaxFaqLarkUrl} className={s.iframe} title="Klarity eFax FAQs" />
        </div>
    );
};

export default FAQ;
